import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-number',
  template: require('./nbinput-number.component.html'),
  styles: [require('./nbinput-number.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputNumberComponent),
      multi: true
    }
  ]
})

export class NbinputNumberComponent implements ControlValueAccessor {
  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};
  public FieldType = NbFieldType;
  registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
  registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
  setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  writeValue(obj: number): void {
    // console.log('in: ',obj);
    if (this._data != obj) {
      this.data = obj;
      // console.log(obj,this._data,this.data);
    }
  }
  onBlur() {
    this.onTouchedCallback();
  }
  @Output() public onSubmit: EventEmitter<any> = new EventEmitter();
  onChange(event){
    this.onSubmit.emit(this.data);
    this.onChangeCallback(this.data);
  }
  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  public disabled;
  @Input()
  public readonly;
  public _calc:number = 0;
  get data(): any {
    if (this._type == NbFieldType.Percentage) {
      this._data = this._calc / 100;
    } else if (this._type == NbFieldType.CurrencyFen) {
      this._data = Math.round(this._calc);
    } else if (this._type == NbFieldType.Currency) {
      this._data = Math.round((this._calc + 0.00001) * 100) / 100;
    } else {
      this._data = this._calc;
    }
    return this._data==null||this._data==undefined?0:this._data;
  };
  @Input()
  set data(val: any) {
    if (!val&&!this._data){
      return;
    }
    // if (val){
    if (this._type == NbFieldType.Percentage || this._type == NbFieldType.Currency) {
      val = Math.round((val + 0.00001) * 10000) / 10000;
    } else if (this._type == NbFieldType.CurrencyFen) {
      val = Math.round(val);
    }
    if (this._data != val) {
      this._data = val;
      if (this._type == NbFieldType.Percentage) {
        this._calc = this._data * 100;
      } else {
        this._calc = this._data;
      }
      // console.log('out: ',this.data);
    }
  }
  public _data:number = 0;
  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }

  public _type:NbFieldType;
  @Input()
  set type(val){
    if (val){
      this._type = val;
      // this.calcData();
    }
  }
  @Input()
  placeholder:string = '';
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-number.component.ts